import React from "react";
import EditableTable from "./signTable";
import "./style.less";
import { Button, Icon, Select } from "antd";
import { getQueryString } from '@/utils/tools';

const clsPrefix = "signatureManage";
const Option = Select.Option;
class SignatureManage extends React.Component {
  constructor() {
    super();
    this.state = {
      status: "all"
    };
  }
  handleAddSignature = () => {
    window.location.href = `/v5/message/addSignature?siteId=${getQueryString('siteId')}`;
  };
  update = data => {
    this.setState({
      signatureList: data
    });
  };
  handleChange = option => {
    this.setState({
      status: option
    });
  };
  
  render() {
    return (
      <div className={clsPrefix}>
        <p className={`${clsPrefix}-prompt`}>
          签名显示在短信内容的最前面，显示这条短信来自哪家公司/产品/网站。因运营商要求，签名需要审核。
        </p>
        <Button
          className="addBtn"
          type="primary"
          size="large"
          onClick={() => {
            this.handleAddSignature();
          }}
        >
          <Icon type="plus-circle" />
          新增签名
        </Button>
        <div className={`${clsPrefix}-content`}>
          <div className={`${clsPrefix}-inputBox`}>
            <span>审核状态: &nbsp;</span>
            <Select
              showSearch
              className={`${clsPrefix}-input`}
              optionFilterProp="children"
              defaultValue="all"
              onChange={option => {
                this.handleChange(option);
              }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="all">全部</Option>
              <Option value="CHECKING">审核中</Option>
              <Option value="SUCCESS">审核成功</Option>
              <Option value="FAIL">审核失败</Option>
            </Select>
          </div>
        </div>
        <div className="tableBox">
          <EditableTable status={this.state.status} update={this.update} />
        </div>
      </div>
    );
  }
}
export default SignatureManage;
